module.exports = __webpack_public_path__ + "img/DSC_2889.376a9b72.png";